import "./Services.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import PrecisionIntelligence from "./sections/PrecisionIntelligence";
import OccasionsWeServe from "./sections/OccasionsWeServe";
import ReadyToDeploy from "./sections/ReadyToDeploy";
import AviationLogisticsFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <GlobalNavigation />
      <PrecisionIntelligence />
      <OccasionsWeServe />
      <ReadyToDeploy />
      <AviationLogisticsFooter />
    </div>;
}